import { RoundedSkeleton } from './RoundedSkeleton';

export const LoadingText = ({ height = 20, width = 150 }) => {
  return <RoundedSkeleton height={`${height}px`} width={`${width}px`} />;
};
